<!--
 * @Author: your name
 * @Date: 2022-03-08 13:42:03
 * @LastEditTime: 2023-06-16 16:00:50
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202204/index.vue
-->
<template>
  <div id="main">
    <div v-if="next == 0" id="home">
      <div @click="ruleDialog" class="myGift myGift3">活动规则</div>
      <div class="goto">
        <div @click="setNext1" class="btn">立即出发</div>
        <div @click="resultDialog" class="link">「韩亚航空」时刻表</div>
      </div>
    </div>
    <div v-if="next == 1" id="box">
      <div class="special">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div @click="handle(index)"
              v-for="(item, index) in imgList"
              :key="index"
              class="swiper-slide slide1"
            >
              <img
                class="swiper swiper2"
                :src="
                  'https://source.qunarzz.com/site/images/wns/20230518-shijianchen-sw-img' +
                  (index + 1) +
                  '.png'
                "
                alt=""
              />
              <img
                v-if="!cache[item.key]"
                src="https://source.qunarzz.com/site/images/wns/20230518-shijianchen-shadow.png"
                class="shadow"
                alt=""
              />
              <img
                v-if="cache[item.key]"
                src="https://source.qunarzz.com/site/images/wns/39631684391788_.pic.jpg"
                class="shadow"
                alt=""
              />
            </div>
          </div>
          <img
            class="txt"
            :class="{ ani: ani }"
            :src="
              'https://source.qunarzz.com/site/images/wns/20230518-shijianchen-sw-txt' +
              current +
              '.png'
            "
            alt=""
          />
        </div>
      </div>
      <div class="goto goto2">
        <div @click="voteKia" class="btn btn2">加入心愿单</div>
        <div class="lookmore">向左向右滑动查看更多心动目的地</div>
      </div>
    </div>
    <div v-if="next == 2" id="last">
      <div @click="getMyPrize(true)" class="myGift">我的奖品</div>
      <div @click="next = 0" class="btn4">返回首页</div>
      <div class="myGift2">剩余{{ times }}次</div>
      <div class="last-show">
        <img
          v-for="(item, index) in record"
          :key="index"
          class="show"
          :src="
            'https://source.qunarzz.com/site/images/wns/20230518-shijianchen-sw-img' +
            item +
            '.png'
          "
          alt=""
        />
      </div>
      <div class="goto">
        <div @click="lottery" class="btn btn2">立即抽奖</div>
        <a
          href="https://flyasiana.com/C/CN/CH/index"
          class="flight"
          ><img
            src="https://source.qunarzz.com/site/images/wns/40691684982773_.pic.jpg"
            alt=""
        /></a>
      </div>
    </div>
  </div>
</template>
<script>
import banner from './components/banner.vue';
import appoint from './components/appoint.vue';
import videoComp from './components/video.vue';
import gotomini2 from './components/gotomini2.vue';
import lineComp from './components/line.vue';
import ruleDialog from './components/dialog/rule/index';
import giftDialog from './components/dialog/gift/gift';
import resultDialog from './components/dialog/gift/result';
import openBox from './components/dialog/gift/openBox'
import moment from 'moment';
export default {
  components: {
    banner,
    appoint,
    videoComp,
    gotomini2,
    lineComp,
  },
  data() {
    return {
      current: 1,
      hasJoin: false,
      times: 0,
      ani: false,
      next: 0,
      record: [],
      cache: {},
      imgList: [
        {
          key: 'SE',
          current: 1,
        },
        {
          key: 'WLD',
          current: 2,
        },
        {
          key: 'BC',
          current: 3,
        },
        {
          key: 'YY',
          current: 4,
        },
        {
          key: 'ND',
          current: 5,
        },
        {
          key: 'JL',
          current: 6,
        },
      ],
    };
  },
  created() {
    let cache = {};
    this.imgList.forEach((item) => {
      cache[item.key] = false;
    });
    this.cache = cache;
  },
  methods: {
    showThumbsList(index) {
      this.$refs.previewer.show(index);
    },
    resultDialog,
    getMyPrize(showDialog) {
      this.commonAjax({
        url: '/commonly/getMyPrzie',
        method: 'get',
        hide: true,
        success: (res) => {
          let hasLottery = false;
          let data = {};
          res.forEach((item) => {
            if (item.prizeCode != 'THANKS') {
              data = item;
              hasLottery = true;
            }
          });
          this.hasLottery = hasLottery;
          if (!data.prizeCode) return;
          if (showDialog && hasLottery) {
            giftDialog({
              giftTip: data.prizeCode,
              winRecordId: data.id,
            });
          }
        },
      });
    },
    lottery() {
      this.commonAjax({
        url: '/commonly/v2/lottery',
        method: 'post',
        success: (data) => {
          giftDialog({
            giftTip: data.code,
            callback: () => {
              // this.next = 0;
            },
          });
          this.init();
        },
      });
    },
    setNext1() {
      var vm = this;
      
      openBox({
        callback:()=>{
          this.next = this.hasJoin ? 2 : 1;
          this.$nextTick(() => {
            setTimeout(()=>{
              vm.ani = true;
            },1000)
            var swiper = new Swiper('.special .swiper-container', {
              slidesPerView: 3,
              spaceBetween: 5,
              centeredSlides: true,
              loop: false,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              on: {
                transitionStart: function () {
                  vm.ani = false;
                },
                slideChangeTransitionEnd: function () {
                  vm.current = this.realIndex + 1;
                  vm.ani = true;
                },
              },
            });
          });
        }
      })
    },
    handle(index) {
      let vm = this;
      let item = vm.imgList[index];
      vm.cache[item.key] = !vm.cache[item.key];
    },
    judgeCacheLen() {
      return Object.values(this.cache).filter((item) => item).length;
    },
    voteRecordDate(callback) {
      this.commonAjax({
        url: '/commonly/voteRecordDate',
        method: 'get',
        success: (data) => {
          callback && callback(data);
        },
      });
    },
    getChannelNum() {
      this.commonAjax({
        url: '/commonly/getKiaNum',
        method: 'get',
        success: (data) => {
          this.times = data;
        },
      });
    },
    voteKia() {
      if (this.judgeCacheLen() != 4) {
        this.$dialog.alert({
          message: '需要选择四个心愿单才可抽奖哦',
        });
        return;
      }
      let keys = [];
      Object.keys(this.cache).forEach((key) => {
        let it = this.cache[key];
        if (it) {
          keys.push(key);
        }
      });
      this.commonAjax({
        url: '/commonly/voteKia?categoryCode=' + keys.join(','),
        method: 'get',
        success: (data) => {
          this.init(true);
        },
      });
    },
    init(setnext) {
      let cache = { ...this.cache };
      this.voteRecordDate((data) => {
        if (data.length > 0) {
          let item = data[0];
          let arr = item.voteCategoryCode.split(',');
          if (arr.length >= 4) {
            this.hasJoin = true;
            if (setnext) {
              this.next = 2;
            }
          }
          let record = [];
          this.imgList.forEach((item) => {
            arr.forEach((child) => {
              if (child == item.key) {
                record.push(item.current);
                cache[item.key] = true;
              }
            });
          });
          this.record = record;
        }
      });
      this.cache = cache;
      this.getChannelNum();
    },
    ruleDialog,
  },
  mounted() {
    let t = +new Date();
    setInterval(()=>{
      let _t = +new Date();
      console.log(moment(_t).diff(t,'days'))
      if(moment(_t).diff(t,'days')>0){
        window.location.reload();
      }
    },1000)
    this.init();
  },
};
</script>
<style lang='less' scoped='true'>
#home {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url(https://source.qunarzz.com/site/images/wns/20230616-shijianchen-bg001.jpg)
    no-repeat;
  background-size: 100% auto;
}
#box {
  width: 100%;
  height: 100vh;
  background: url(https://source.qunarzz.com/site/images/wns/20230616-shijianchen-hanya.jpg)
    no-repeat;
  background-size: 100% auto;
}
#last {
  width: 100%;
  height: 812px;
  background: url(https://source.qunarzz.com/site/images/wns/20230616-shijianchen-002.jpg)
    no-repeat;
  background-size: 100% auto;
  .goto {
    top: 570px;
  }
}
.goto {
  position: absolute;
  left: 0;
  top: 550px;
  width: 100%;
  font-size: 16px;
}
.link {
  display: inline-block;
  position: relative;
  color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: calc(100% + 10px);
    bottom: -7px;
    border-bottom: 1px solid #fff;
  }
}
.goto2 {
  top: 560px;
  font-size: 12px;
}
.lookmore {
  color: #fff;
  font-size: 10px;
  margin-top: 10px;
}
.btn {
  width: 184px;
  height: 43px;
  background: linear-gradient(0deg, #a50034 0%, #e20a4e 100%);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding-right: 40px;
  font-size: 19px;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  &:before {
    position: absolute;
    content: '';
    width: 32px;
    height: 26px;
    background: url(https://source.qunarzz.com/site/images/wns/20230518-shijianchen-btn.png)
      no-repeat;
    background-size: 100% auto;
    left: 30px;
    top: 8px;
  }
}
.btn4 {
  width: 80px;
  height: 24px;
  background: linear-gradient(0deg, #a50034 0%, #e20a4e 100%);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  right: 10px;
  top: 10px;
}
.btn2 {
  justify-content: center;
  padding-right: 0;
  &:before {
    content: unset;
  }
}

.special {
  position: absolute;
  top: 300px;
  height: 150px;
  width: 100%;
  .swiper-container {
    width: 700px;
    transform: translateX(-50%);
    position: relative;
    left: 50%;
    margin-top: -90px;
    overflow: inherit;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    transition: 300ms;
    height: 345px;
    // transform: scale(0.8);
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    // transform: scale(1.3);
    // border: 2px solid #fff;
    border-radius: 6px;
    .shadow {
      display: block;
    }
    overflow: hidden;
    .txt {
      opacity: 1;
    }
  }
}
.txt {
  position: absolute;
  opacity: 0;
  left: 50%;
  bottom: 0;
  width: 290px;
  margin-left: -125px;
  z-index: 10;
}
.ani {
  transition: all 1s ease-in-out;
  opacity: 1;
}
.shadow {
  position: absolute;
  left: 0%;
  top: 0;
  width: 230px;
  height: 306px;
}
.last-show {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 285px;
  margin: 0 auto;
  position: relative;
  top: 220px;
  .show {
    width: 140px;
    height: 166px;
    margin-bottom: 5px;
  }
}
.myGift {
  position: absolute;
  right: 20px;
  top: 187px;
  width: 72px;
  height: 27px;
  background: #0983de;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10;
  border-radius: 14px;
}
.myGift2 {
  position: absolute;
  left: 15px;
  top: 598px;
  width: 72px;
  height: 27px;
  background: #0983de;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10;
  font-size: 13px;
  border-radius: 14px;
}
.myGift3 {
  top: 190px;
  width: 48px;
  height: 18px;
  right: 14px;
  font-size: 9px;
}
.flight {
  width: 347px;
  display: block;
  margin: 20px auto auto;
}
</style>